<template>
  <NuxtLayout
    name="main-view"
    :hasBackButton="true"
    :headline="$t('dbc-contract-credit')"
  >
    <Card :pt="specialCardPassThrough">
      <template #header
        >{{ $t('dbc-contract-total-credit') }}
        <span class="whitespace-nowrap font-semibold">
          {{ totalCredits }}
        </span>
      </template>
      <template #content>
        <div v-for="credit in credits">
          <span>
            {{ getCurrencyString(credit.value) }}
            {{ $t('dbc-text-credit-valid-until') }}
            {{ dayjs(credit.validTo).format('DD.MM.YYYY') }}
          </span>
        </div>
        <DbcBanner severity="info" :message="$t('dbc-contract-hint-credit')" />
      </template>
    </Card>
  </NuxtLayout>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import { useCustomerStore } from '../../../stores/customer'
import Card from 'primevue/card'

const customerStore = useCustomerStore()
const { credits, totalCredits } = storeToRefs(customerStore)
</script>
